import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from '../../../Note/AL/Common.module.css';
import { AlSection } from 'PatientCareCenter/Note/AL';
import { AlWpTestRow } from 'PatientCareCenter/Note/WorkProgram/AL';
import { codeValidForAdmit } from '_helpers';
import { CancelButton, StatusGood, AddButton } from '_components';
class AlWpTest extends React.Component {

    constructor(props) {
        super();
        this.state = {
            showWarning: false,
            start: props.startTime,
            end: props.endTime,
            break: props.breakTime
        };
    }

    startTime(time) {
        this.setState({ start: time }, () => {

            if (!this.state.start) {
                this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMEWORKPROG']);
                this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLWORKPROGBREAKS']);
                this.setState({ break: '', total: '' });
                return;
            }

            if (this.state.end) {
                this.calculateTotalMinutes(this.state.start, this.state.end, this.state.break);
            }
        })
    }

    endTime(time) {
        this.setState({ end: time }, () => {
            if (!this.state.end) {
                this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMEWORKPROG']);
                this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLWORKPROGBREAKS']);
                this.setState({ break: '', total: '' });
                return;
            }
            if (this.state.start) {
                this.calculateTotalMinutes(this.state.start, this.state.end, this.state.break);
            }
        });
    }

    breakTime(time) {
        this.setState({ break: time }, () => {
            if (this.state.start && this.state.end) {
                this.calculateTotalMinutes(this.state.start, this.state.end, this.state.break);
            }
        });
    }

    calculateTotalMinutes = (start, end, breakMinutes = 0) => {
        if (!start || !end) return;

        const [startHours, startMinutes] = start.split(':').map(Number);
        const [endHours, endMinutes] = end.split(':').map(Number);

        const startDate = new Date();
        startDate.setHours(startHours, startMinutes, 0);

        const endDate = new Date();
        endDate.setHours(endHours, endMinutes, 0);

        let diffMs = endDate - startDate;
        let diffMinutes = Math.floor(diffMs / 60000);

        if (diffMinutes < 0) diffMinutes = 0;

        // Deduct break time
        const validBreak = Math.max(0, parseInt(breakMinutes, 10) || 0);
        const totalMinutes = Math.max(0, diffMinutes - validBreak);

        this.props.updateAlTime(undefined, undefined, totalMinutes, this.props.xlno, 'XLTIMEWORKPROG', this.props.noteId);
    };

    add() {
        if ((this.props.trtValid1 || this.props.trtValid2) || ((!this.props.trtValid1 && !this.props.trtValid2) && this.props.wpTests.length > 0)) {
            this.props.addAlRow(this.props.noteId, 'MLWORKPROG', 'XLWP', 'XLWPNO', 'XLWPXLNO', this.props.xlno, 'NEW_XLWPNO');
            this.setState({ showWarning: false });
        } else if (!this.props.trtValid1 && !this.props.trtValid2 && this.props.wpTests.length === 0) {
            this.setState({ showWarning: true });
        }
    }

    componentDidUpdate() {
        if (this.props.wpTests.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMEWORKPROG']);
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLWORKPROGSTART']);
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLWORKPROGEND']);
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLWORKPROGBREAKS']);
            if (this.state.start !== '' || this.state.end !== '' || this.state.break !== '') {
                this.setState({
                    start: '',
                    end: '',
                    break: ''
                });
            }
        }
    }

    confirmPending() {
        this.props.addAlRow(this.props.noteId, 'MLWORKPROG', 'XLWP', 'XLWPNO', 'XLWPXLNO', this.props.xlno, 'NEW_XLWPNO');
        this.setState({ showWarning: false });
    }

    remove() {
        this.setState({ showWarning: false });
    }

    updatePerformedValue() {
        this.props.updateDefWpALPerformed(this.props.noteType, this.props.pk);
    }

    render() {
        return (
            <AlSection
                id='al_wp'
                name='Work Program (97545/97546)'
                timeField='XLTIMEWORKPROG'
                timeRequired={this.props.totalTime === null && this.props.containsPerformed ? true : false}
                startTimeRequired={this.props.startTime === null && this.props.containsPerformed ? true : false}
                endTimeRequired={this.props.endTime === null && this.props.containsPerformed ? true : false}
                totalTimeVisible={this.props.wpTests.length > 0 && (this.props.noteType === 1 || this.props.noteType === 2 || this.props.noteType === 5 || this.props.noteType === 6)}
                timeVisible={false}
                disableTime={true}
                startTimeField='XLWORKPROGSTART'
                endTimeField='XLWORKPROGEND'
                breakField='XLWORKPROGBREAKS'
                showStartEndTime
                startEndTimeNoteVisibility={this.props.wpTests.length > 0 ? true : false}
                trackAssist={this.props.trackAssist}
                onAdd={() => this.add()}
                onStartTime={(time) => this.startTime(time)}
                onEndTime={(time) => this.endTime(time)}
                onBreakTime={(time) => this.breakTime(time)}
                className={this.props.className}
                totalTime={this.props.totalTime}
            >
                {this.state.showWarning &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }

                {this.props.wpTests.length > 0 &&
                    <>
                        <div className={styles.row}>
                            <span className={styles.button_spacer} />
                            <span className={styles.col1_activity}>Activity</span>
                            <span className={styles.col6_header}>Sets/Reps/Weight/Time</span>
                            <span className={styles.col4_header}>Performed</span>
                        </div>
                        {this.props.showSpeedBtnNoteTypes.includes(this.props.noteType) &&
                            (<div className={styles.speedBtn_row}>
                                <AddButton size='extra-small' title={'Performed'} onClick={() => this.updatePerformedValue()} />
                            </div>)
                        }
                    </>
                }
                {Object.keys(this.props.wpTests)
                    .map(key => {
                        const result = this.props.wpTests[key];
                        return (
                            <AlWpTestRow key={result.XLWPNO} id={result.XLWPNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        updateAlTime: bindActionCreators(noteActions.updateALTime, dispatch),
        updateDefWpALPerformed: bindActionCreators(noteActions.updateDefWpALPerformed, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;
    let containsPerformed = state.entities.notes.MLWORKPROG &&
        Object.keys(state.entities.notes.MLWORKPROG)
            .filter(key => {
                return (state.entities.notes.MLWORKPROG[key].XLWPXLNO === xlno && state.entities.notes.MLWORKPROG[key].XLWPPERFORMED)
            }).length > 0 ? true : false;

    let startTime = (noteType === 1 || noteType === 2 || noteType === 5 || noteType === 6) && state.entities.notes.MLEXLOG[xlno]['XLWORKPROGSTART'];
    let endTime = (noteType === 1 || noteType === 2 || noteType === 5 || noteType === 6) && state.entities.notes.MLEXLOG[xlno]['XLWORKPROGEND'];
    let breakTime = (noteType === 1 || noteType === 2 || noteType === 5 || noteType === 6) && state.entities.notes.MLEXLOG[xlno]['XLWORKPROGBREAKS'];
    let totalTime = (noteType === 1 || noteType === 2 || noteType === 5 || noteType === 6) && state.entities.notes.MLEXLOG[xlno]['XLTIMEWORKPROG'];
    let showSpeedBtnNoteTypes = [1, 2, 5, 6];
    let trtValid1 = codeValidForAdmit(epno, '97545') || codeValidForAdmit(epno, '97545E');
    let trtValid2 = codeValidForAdmit(epno, '97546') || codeValidForAdmit(epno, '97546E');

    return {
        noteId,
        pk,
        noteType,
        xlno,
        trtValid1,
        trtValid2,
        showSpeedBtnNoteTypes,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMEWORKPROG,
        wpTests: Object.keys(state.entities.notes.MLWORKPROG)
            .filter(key => {
                return (state.entities.notes.MLWORKPROG[key].XLWPXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLWORKPROG[a].XLWPNO - state.entities.notes.MLWORKPROG[b].XLWPNO)
            .map(key => state.entities.notes.MLWORKPROG[key]),
        trackAssist,
        isLicensed,
        totalTime,
        startTime,
        endTime,
        breakTime,
        containsPerformed
    };
}

const connectedAlWpTest = connect(mapStateToProps, mapDispatchToProps)(AlWpTest);
export { connectedAlWpTest as AlWpTest };

